import $ from 'jquery'
import { directiveSettings } from '../../utils/parse';

export default function productDirective(context=document.body) {
	const $context = $(context);

	$context.find('[sw-product]').each(function() {
		const $product = $(this);
		const $productButton = $product.find('.product_button');
		const $price = $product.find('.product_price');
		const $sku = $product.find('.product_sku');
		const $qty = $product.find('.product_qty');
		const $text = $product.find('.product_text');
		const $packSize = $product.find('.product_pack-size');
		const $purchasableId = $product.find('input[name="purchasableId"]');
		const $variantsContainer = $product.find('[sw-product-variants]');
		const $variantSelectors = $variantsContainer.find('select');

		const buttonLink = $productButton.attr('href').split('?')[0];
		const variantsData = directiveSettings($product.attr('sw-product'));
		const variantsSettings = directiveSettings($variantsContainer.attr('sw-product-variants'), {
			restrict: false,
		}, 'restrict');

		function getVariants(string) {
			return string.split('|');
		}

		function getValidVariants() {
			let validVariants = [];

			$variantSelectors.each(function() {
				const $selector = $(this);
				const selectValue = $selector.val();
				let variants = [];

				if (selectValue !== '') {
					const options = getVariants(selectValue);
					let validOptions;
					if (validVariants.length > 0) {
						validOptions = validVariants[validVariants.length - 1].filter(v => options.includes(v));
					} else {
						validOptions = options;
					}

					if (validOptions.length > 0) {
						variants = variants.concat(validOptions);
					} else {
						$selector.children('option').each(function() {
							const options = getVariants($(this).val());
							variants = variants.concat(options);
						});
					}
				} else {
					$selector.children('option').each(function() {
						const options = getVariants($(this).val());
						variants = variants.concat(options);
					});
				}

				if (validVariants.length > 0) {
					validVariants.push(validVariants[validVariants.length - 1].filter(v => variants.includes(v)));
				} else {
					validVariants.push(variants);
				}
			});

			return validVariants;
		}

		function getCommonValues(array) {
			let newArray = null;

			array.forEach(function(row) {
				if (newArray !== null) {
					newArray = newArray.filter(v => row.includes(v));
				} else {
					newArray = row;
				}
			});

			if (newArray !== null && newArray.length > 0 && newArray[0] !== '') {
				return newArray;
			} else {
				return null;
			}
		}

		function allValidSelections(commonVariant) {
			let allValid = true;

			$variantSelectors.each(function(i) {
				const val = getVariants($(this).val());

				if (val[0] === '' || val.indexOf(commonVariant) === -1) {
					allValid = false;
				}
			});

			return allValid;
		}

		function setButtonState() {
			const purchasable = $purchasableId.val()
			if (purchasable !== '') {
				const qty = $qty.val();

				$productButton.attr('href', `${buttonLink}?v=${purchasable}&qty=${qty}`)
				              .removeClass('is-disabled');
			} else {
				$productButton.removeAttr('href')
				              .addClass('is-disabled');
			}
		}

		$variantSelectors.on('change', function() {
			const validVariants = getValidVariants();
			const commonVariants = getCommonValues(validVariants);

			if (commonVariants !== null && commonVariants.length === 1 && allValidSelections(commonVariants[0])) {
				const variant = `v${commonVariants[0]}`;
				const variantData = variantsData[variant];
				$price.html(variantData.price);
				$sku.html(variantData.sku);
				$text.html(`<p>${variantData.text}</p>`);
				$packSize.html(variantData.packSize);
				$purchasableId.val(commonVariants[0]);

				const wasPrice = !$price.hasClass('is-not-price');
				const isPrice = variantData.price.substr(0, 1) === '$';

				if (wasPrice && !isPrice) {
					$price.addClass('is-not-price');
				} else if (!wasPrice && isPrice) {
					$price.removeClass('is-not-price');
				}

				if (variantsSettings.restrict) {
					$variantSelectors.removeAttr('disabled');
				}
			} else if (variantsSettings.restrict) {
				const selected = $variantSelectors.index(this);
				const lastEnabled = $(this).val() !== '' ? selected + 1 : selected;

				$variantSelectors.each(function(i) {
					const $selector = $(this);

					if (i > lastEnabled) {
						$selector.attr('disabled', true);
					} else if ($selector.attr('disabled')) {
						$selector.removeAttr('disabled');
					}

					if (i >= lastEnabled && i !== 0) {
						$selector.children('option').each(function() {
							const $option = $(this);
							const optionValue = $option.val();
							const optionVariants = getVariants(optionValue);
							let removeHidden = false;
							let newCommonVariants = null;
							if (commonVariants === null) {
								removeHidden = true;
							} else {
								newCommonVariants = validVariants[i].filter(v => optionVariants.includes(v));

								if (optionValue === '' || newCommonVariants.length > 0) {
									removeHidden = true;
								}
							}

							if (removeHidden) {
								$option.removeClass('+hidden');
							} else {
								$option.addClass('+hidden');
							}
						});
					}
				});
			} else {
				$price.addClass('is-not-price');
				$price.html('N/A');
				$sku.html('N/A');
				$text.html('N/A');
				$packSize.html('N/A');
				$purchasableId.val('');
			}

			setButtonState();
		});

		$qty.on('change', setButtonState);
	});
}



// WEBPACK FOOTER //
// ./source/scripts/directives/commerce/product.js